var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import DuplicatePersonTable from "../../Presentational/DuplicatePerson/DuplicatePersonTable";
const searchArgs = {
    ezMerge: true,
    ignored: false,
    merged: false,
};
const actions = [
    {
        id: 1,
        name: "Ignore",
        icon: "ban",
        title: "Ignore",
    },
];
const DuplicatePersonAutoMergeTab = (_a) => {
    var { id } = _a, props = __rest(_a, ["id"]);
    return (_jsx(DuplicatePersonTable, Object.assign({}, props, { actions: actions, search: Object.assign(Object.assign({}, searchArgs), { ruleSetIds: [id] }) })));
};
export default DuplicatePersonAutoMergeTab;
